import { useAuth } from '@clerk/react-router';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { paths } from '~/routing/routes';

export const LogoutPage = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const hasStartedLogout = useRef(false);

  useEffect(() => {
    if (hasStartedLogout.current) return;

    hasStartedLogout.current = true;
    signOut({ redirectUrl: paths.landing }).catch((err) => {
      // Clerk normally handles the redirect itself; a rejection (network blip,
      // session already invalidated) would otherwise leave us stuck on the
      // loading copy. Reset the ref so a re-mount can retry, then escape.
      console.error('Logout failed', err);
      hasStartedLogout.current = false;
      navigate(paths.landing, { replace: true });
    });
  }, [signOut, navigate]);

  return (
    <div className="flex h-full items-center justify-center bg-white">
      <p className="body-text text-grey-500">Signing out...</p>
    </div>
  );
};
